import { cn } from "@/lib/utils";
import { MARKDOWN_PREVIEW_PROSEMIRROR_LIST_CLASS } from "@/features/sparxsEditor/components/organisms/richTextEditor/markdown/markdownPreviewClasses";

const CONTENT_AREA_DEFAULT = "min-h-[120px]";

const CONTENT_AREA_CTA = "min-h-9 max-h-9 overflow-y-auto";

const EDITOR_CONTENT_CLASS = cn(
  "w-full rounded-none border-0 bg-transparent",
  "px-3 py-2 text-sm ring-offset-background",
  `
    focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2
    focus-visible:outline-none
  `,
  `
    [&_p]:my-1
    [&_p:first-child]:mt-0
    [&_p:last-child]:mb-0
  `,
);

const EDITOR_CONTENT_CLASS_CTA = cn(
  "w-full rounded-none border-0 bg-transparent",
  "px-3 py-1 text-sm ring-offset-background",
  `
    focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2
    focus-visible:outline-none
  `,
  "[&_p]:my-0",
);

export type RichTextEditorContentAreaVariant = "default" | "cta";

export const BUBBLE_MENU_CLASS = cn(
  "flex items-center gap-1",
  "rounded-md border border-(--console-border-input) bg-background",
  "px-2 py-1 shadow-none",
);

export const RICH_TEXT_EDITOR_ROOT_CLASS = cn(
  `
    flex flex-col overflow-hidden rounded-md border
    border-(--console-border-input) bg-background
  `,
  "min-w-[500px] font-normal not-italic shadow-none",
);

/** Content area above lift-tabs footer: bottom divider only, same token as RTE chrome. */
export const RTE_LIFT_TABS_CONTENT_BORDER_CLASS = cn(
  "border-0 border-b border-(--console-border-input)",
);

export const editorProseMirrorClassForVariant = (
  contentAreaVariant: RichTextEditorContentAreaVariant,
): string =>
  contentAreaVariant === "cta"
    ? cn(
        CONTENT_AREA_CTA,
        EDITOR_CONTENT_CLASS_CTA,
        MARKDOWN_PREVIEW_PROSEMIRROR_LIST_CLASS,
      )
    : cn(
        CONTENT_AREA_DEFAULT,
        EDITOR_CONTENT_CLASS,
        MARKDOWN_PREVIEW_PROSEMIRROR_LIST_CLASS,
      );

export const contentAreaLayoutClassForVariant = (
  contentAreaVariant: RichTextEditorContentAreaVariant,
): string =>
  contentAreaVariant === "cta" ? CONTENT_AREA_CTA : CONTENT_AREA_DEFAULT;
